module.exports = require("@swa-ui/core/src/Link/Link.module.scss");